const DISCRIMINATOR = "status";

export { DISCRIMINATOR };
